import React, { useRef } from 'react'
import style from './style.module.scss'

type Props = {
    id?: string
    label: string
    date: string
    onChange: Function
}

export const DatePicker: React.FC<Props> = ({
    id = `date-picker-${(Math.random() + 1).toString(36).substring(7)}`,
    label,
    date,
    onChange,
}) => {
    const inputRef = useRef<any>(null)

    const handleShowPicker = () => {
        if (!inputRef) return
        inputRef?.current?.showPicker()
    }

    return (
        <div className={style.datePickerContainer}>
            <div className={style.header}>
                <label htmlFor={id}>{label}</label>

                {date && (
                    <button
                        className={style.resetButton}
                        onClick={() => onChange('')}
                        type="button"
                    >
                        Effacer
                    </button>
                )}
            </div>

            <div className={style.inputContainer}>
                <input
                    ref={inputRef}
                    id={id}
                    value={date}
                    onChange={(e) => onChange(e.target.value)}
                    type="date"
                    onClick={handleShowPicker}
                />
                <i className={'fi-rs-calendar'} />
            </div>
        </div>
    )
}

export default DatePicker
